import * as React from 'react';
import { Input, Modal, Checkbox, Alert } from 'antd';

import Form, { FormItem } from '../../../../../../components/Form';
import PriceInput from '../../../../../../components/Others/PriceInput';

export interface IPriceDetailProps {
  weightRange: string;
  prices: GQL.IDeliveryMethodPrice[];
  currencies: GQL.ICurrency[];
  onSave: (weightRange: string, prices: GQL.IDeliveryMethodPrice[]) => void;
  onCancel: () => void;
}

export interface IPriceDetailState {
  prices: GQL.IDeliveryMethodPrice[];
  fromWeight?: number;
  toWeight?: number;
  active: boolean;
}

export default class PriceDetail extends React.Component<IPriceDetailProps, IPriceDetailState> {

  constructor(props: IPriceDetailProps) {
    super(props);

    this.state = {
      prices: [...props.prices],
      fromWeight: (props.prices && props.prices.length > 0 ? props.prices[0].fromWeight || undefined : undefined),
      toWeight: (props.prices && props.prices.length > 0 ? props.prices[0].toWeight || undefined : undefined),
      active: (props.prices && props.prices.length > 0 ? props.prices[0].active !== false : true),
    };

    this.onChange = this.onChange.bind(this);
    this.save = this.save.bind(this);
  }

  public render() {
    const { prices } = this.state;

    return (
      <Modal
        maskClosable={false}
        style={{ top: '5vh' }}
        title={`Price by weight`}
        visible={true}
        footer={null}
        onCancel={() => this.props.onCancel()}
      >
          <Form 
            onSubmit={this.save}
            onCancel={() => this.props.onCancel()}
          >
            <FormItem label="From order weight (kg)">
              <Input
                name={'fromWeight'}
                type={'number'}
                autoFocus={true}
                placeholder={'From order weight'}
                addonAfter={'kg'}
                value={this.state.fromWeight}
                onChange={(e: any) => {
                  let w = e.target.value;
                  if (isNaN(parseFloat(w))) {
                    w = parseFloat(w);
                  }
                  this.onChange({ target: { name: e.target.name, value: w || null } });
                }}
              />
            </FormItem>
            <FormItem label={`To order weight (kg)`}>
              <Input
                name={'toWeight'}
                type={'number'}
                placeholder={`To order weight`}
                addonAfter={'kg'}
                value={this.state.toWeight}
                onChange={(e: any) => {
                  let w = e.target.value;
                  if (isNaN(parseFloat(w))) {
                    w = parseFloat(w);
                  }
                  this.onChange({ target: { name: e.target.name, value: w || null } });
                }}
              />
            </FormItem>
            <FormItem label={`Price`} required={this.state.active === true}>
              <PriceInput
                name={'prices'}
                mode={'priceWithout'}
                prices={prices.map((price: GQL.IDeliveryMethodPrice) => ({ 
                  currencyId: price.currencyId, 
                  priceWithout: price.priceWithout
                })) as any}
                onChange={this.onChange}
              />
            </FormItem>
            <FormItem>
              <Checkbox
                name={'active'}
                checked={this.state.active !== false}
                onChange={this.onChange}
              >
                Active
              </Checkbox>
            </FormItem>
          </Form>
      </Modal>
    );
  }

  private onChange(e: any, language?: string) {
    const { name, value, checked } = e.target;

    const inputValue = (value !== undefined ? value : checked);

    const newValue = (language
      ? { [name]: { ...this.state[name], [language]: inputValue } }
      : { [name]: inputValue });

    this.setState({
      ...this.state, ...newValue
    });
  }

  private save() {
    // ceny pro uložení
    let pricesToSave = this.state.prices
      .map((price: GQL.IDeliveryMethodPrice) => {
        return {
          ...price,
          fromWeight: this.state.fromWeight,
          toWeight: this.state.toWeight,
          active: this.state.active,
        } as GQL.IDeliveryMethodPrice;
      });

    // ceny pro validaci
    const pricesToValidate = [...pricesToSave]
      .filter((price: GQL.IDeliveryMethodPrice) => {
        return !price.active || (price.active === true && price.priceWithout && price.priceWithout >= 0);
      });

    // cena dle váhy je aktivní, ale není zadána cena
    if (this.state.active === true && pricesToValidate && pricesToValidate.length === 0) {
      Modal.error({
        title: `Delivery price`,
        content: (
          <span>
            Please enter price for this delivery
          </span>
        ),
      });

    } else {
      // není zadána žádná cena
      if (pricesToSave && pricesToSave.length === 0) {
        pricesToSave = [{
          currencyId: null,
          priceWithout: null,
          fromWeight: this.state.fromWeight,
          toWeight: this.state.toWeight,
          active: this.state.active,
        } as any];
      }

      this.props.onSave(this.props.weightRange, pricesToSave);
    }
  }
}



// WEBPACK FOOTER //
// ./src/scenes/DeliveryMethods/DeliveryMethodDetail/components/PricesByWeight/components/PriceDetail.tsx